<template lang="pug">
  section
    .hero.is-light
      .hero-body
        h1.title.is-5
          span.icon
            i.fas.fa-box.fa-sm.fa-fw
          span
            | {{ title }}

    section.section
      .field.is-grouped
        .control
          <!--button(class="button is-primary is-small" @click="isComponentModalActive = true")-->
            button(class="button is-danger" @click="openNew()")
              b-icon(pack="fas" custom-class="fa-sm fa-plus")
              span
                | 新規作成
        .control
          a(class="button is-primary" :href="list_path")
            span
              | {{ list_label }}
          <!--| 絞り込む-->
        <!--b-modal(:active.sync="isComponentModalActive" has-modal-card)-->
          <!--search-modal-form(:formProps.sync="formProps" v-on:on-search="onSearch")-->
      .scroll-table
        b-table(
            :data="data"
            :loading="loading"
            paginated
            narrowed
            hoverable
            striped
            icon-pack="fa"
            backend-pagination
            :total="total"
            :current-page="page"
            :per-page="perPage"
            @page-change="onPageChange"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
            )
          template(slot-scope="props")
            b-table-column(field="sid" label="受注管理ID" width="120" sortable)
              a.button.is-rounded.is-info.is-small(@click="onClick(props.row)")
                | {{ props.row.sid }}
            b-table-column(field="sid" label="直送" width="40" centered)
              b-checkbox(v-model="props.row.direct_flag" disabled)
            b-table-column(field="book_types" label="書籍種類" width="80")
              | {{ props.row.book_types }}
            b-table-column(field="order_number" label="受注件数" width="80")
              | {{ props.row.accepting_order_items_count }}
            b-table-column(field="order_number" label="受注冊数" width="80")
              | {{ props.row.order_number }}
            b-table-column(field="delivered_number" label="配本済冊数" width="80")
              | {{ props.row.manipulated_number }}
            b-table-column(field="" label="未配本冊数" width="80")
              | {{ props.row.order_number - props.row.manipulated_number }}
            b-table-column(field="accepting_date" label="入力日時" width="120")
              | {{ formatTime(props.row.accepting_date) }}
            b-table-column(field="user_id" label="作成者" width="100")
              | {{ userName(props.row.user_id) }}
            b-table-column(field="" label="削除" width="")
              b-field
                a.delete(@click="clickDeleteButton(props.row, $event)")

</template>

<script>
  // import SearchModalForm from './final_book_shops_search_modal_form'

  export default {
    name: 'accepting-orders-table',
    props: {
      list_label: {
        type: String,
        required: true
      },
      list_path: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      current_model: {
        type: String,
        required: true
      },
      registered: {
        type: Boolean
      }
    },
    data() {
      return {
        data: [],
        total: 0,
        loading: false,
        sortField: 'id',
        sortOrder: 'desc',
        defaultSortOrder: 'desc',
        page: 1,
        perPage: 100,
        isComponentModalActive: false,
        formProps: {
          shop_code_cont: '',
          name_cont: '',
          group_code_cont: '',
          telephone_cont: '',
          prefecture_cont: '',
          s: ''
        },
        default_params: null,
      }
    },
    computed: {
      users(){ return this.$store.getters['Users/records'] },
    },
    // components: { 'search-modal-form': SearchModalForm },
    methods: {
      openNew(){
        window.location.href = `/users/accepting_orders/new`
      },
      userName(id){
        if (!id) return ''
        let tmp = this.users
            .filter(user => user.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      formatTime(dateTime) {
        return this.$moment(dateTime).format("YYYY.MM.DD HH:mm")
      },
      /*
       * Load async data
       */
      loadAsyncData() {
        const params = [
          `page=${this.page}`,
          `per_page=${this.perPage}`,
          Object.keys(this.formProps).map((key) => {
            return `q[${key}]=${this.formProps[key]}`
          }).join('&')
        ].join('&')

        this.loading = true
        this.$http.get(`/api/v1/${this.current_model}?${params}`)
            .then(({data}) => {
              this.data = []
              let currentTotal = data.total_results
              if (data.total_results / this.perPage > 1000) {
                currentTotal = this.perPage * 1000
              }
              this.total = currentTotal
              data[this.current_model].forEach((item) => {
                this.data.push(item)
              })
              this.loading = false
              if(this.default_params != params)
                history.pushState(null, null, `/users/${this.current_model}?${params}`)
              this.displayData = this.data
            })
            .catch((error) => {
              this.data = []
              this.total = 0
              this.loading = false
              throw error
            })
      },
      onSearch(){
        this.onPageChange(1)
      },
      /*
       * Handle page-change event
       */
      onPageChange(page) {
        this.page = page
        this.loadAsyncData()
      },
      /*
       * Handle sort event
       */
      onSort(field, order) {
        this.page = 1
        this.sortField = field
        this.sortOrder = order
        this.formProps.s = `${this.sortField} ${this.sortOrder}`
        this.loadAsyncData()
      },
      onClick(row){
        window.location.href = `/users/${this.current_model}/${row.id}/edit`
      },
      changeLinkVisibility(event, visibility) {
        event.target.style.visibility = visibility
      },
      clickDeleteButton(accepting_order, event){
        const message = `
          受注管理ID: ${accepting_order.sid}
          受注件数: ${accepting_order.accepting_order_items_count}
          受注冊数: ${accepting_order.order_number}
          未配本冊数: ${accepting_order.order_number - accepting_order.manipulated_number}
          入力日時: ${this.formatTime(accepting_order.accepting_date)}
          作成者: ${this.userName(accepting_order.user_id)}
          `

        this.$dialog.confirm({
          title: '以下の受注を削除してもよろしいですか?',
          message: message,
          onConfirm: () => {
            this.changeLinkVisibility(event, 'hidden')
            this.loading = true

            this.$http.delete(`/api/v1/${this.current_model}/${accepting_order.id}`)
                .then(({data}) => {
                  this.data = this.data.filter((order) => order.id !== accepting_order.id)
                  this.changeLinkVisibility(event, '')
                  this.loading = false
                  this.$toast.open({
                    message: '削除に成功しました。',
                    type: 'is-danger',
                    position: 'is-bottom'
                  })
                })
                .catch((error) => {
                  this.loading = false
                  this.changeLinkVisibility(event, '')
                  this.$toast.open({
                    message: '削除エラーです。確認してください。',
                    type: 'is-danger',
                    position: 'is-bottom',
                    duration: 4000
                  })
                  throw error
                })
          }
        })
      }
    },
    filters: {
      /**
       * Filter to truncate string, accepts a length parameter
       */
      truncate(value, length) {
        return value.length > length
            ? value.substr(0, length) + '...'
            : value
      }
    },
    created(){
      this.default_params = [
        `page=${this.page}`,
        Object.keys(this.formProps).map((key) => {
          return `q[${key}]=${this.formProps[key]}`
        }).join('&')
      ].join('&')
    },
    mounted() {
      if(this.registered) {
        this.$toast.open({
          message: "データが登録されました。",
          type: 'is-danger',
          position: 'is-bottom'
        })
      }
      let queries = this.$qs.parse(location.search.slice(1))

      if(queries) {
        let q = queries.q
        if(q) {
          Object.keys(this.formProps).forEach((key) => {
                if (q[key]) {
                  this.formProps[key] = `${q[key]}`
                }
              }
          )
        }
        if (queries.page)
          this.page = parseInt(queries.page)
      }
      this.loadAsyncData()
      this.$store.dispatch('Users/fetch', 'users')
    }
  }
</script>
